import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-searchinput', 'clear', 'Išvalyti įvestį');
Labels.set('ui-searchinput', 'search', 'Paieška');
